import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { BaseComponent } from '@shared/component/base/base.component';
import { IChartData, TaxSummary, TaxSummaryTypeEnum } from 'taxtank-core';

/**
 * Component contain user's common tax position information
 */
@Component({
  selector: 'app-tax-summary-overview',
  templateUrl: './tax-summary-overview.component.html',
  styleUrls: ['./tax-summary-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class TaxSummaryOverviewComponent extends BaseComponent {
  @Input() view: TaxSummaryTypeEnum;
  @Input() taxSummaryActual: TaxSummary;
  @Input() taxSummaryForecast: TaxSummary;

  get chartData(): IChartData[] {
    return [
      { name: 'Work Tank', data: this.taxSummary.work.netAmount },
      { name: 'Property Tank', data: this.taxSummary.property.netAmount },
      { name: 'Other Tank', data: this.taxSummary.holdings.netAmount },
    ];
  }

  get taxSummary(): TaxSummary {
    return this.isActuals ? this.taxSummaryActual : this.taxSummaryForecast;
  }

  get isActuals(): boolean {
    return this.view === TaxSummaryTypeEnum.ACTUALS;
  }
}
